import { useMutation } from '@tanstack/react-query';
import type { AgentApiCompaniesItem } from '@/types/serializers';
import type { LISTED_PHASE_ITEMS } from '../constants';

type CreateCompanyParams = {
  name: string;
  organization_user_id?: number;
  company_information?: {
    description?: string;
    president_name?: string;
    official_url?: string;
    address?: string;
    established_date?: string;
    listed_phase?: (typeof LISTED_PHASE_ITEMS)[number]['value'];
    number_of_employees?: number | null;
    industry_id?: number;
    corporate_number?: string;
  };
  custom_data?: Array<{ field_id: number; content: string }>;
};

export default function usePostCompany() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (body: CreateCompanyParams) => {
      const res = await fetch('/agent/api/companies', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(body),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        // バックエンド(Shared::SimpleResource)は単数キー `error` に理由文字列を返す。
        // 旧実装は複数形 `errors` を読んでいて常に undefined→'Create failed' に潰れていた(#2835)。
        const message =
          err.error || (Array.isArray(err.errors) ? err.errors.join(', ') : '') || 'Create failed';
        throw new Error(message);
      }
      const data: AgentApiCompaniesItem = await res.json();
      return data;
    },
  });
}
